import { render } from "./CheckBox.vue?vue&type=template&id=794074c7&ts=true"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"

import "./CheckBox.vue?vue&type=style&index=0&id=794074c7&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__